import React, { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Formik } from "formik";
import * as Yup from "yup";

import { Common, InviteUser, MESSAGES, SessionStorageKeys } from "../../helper";
import { isEmptyObject, SessionStorage } from "../../util";
import { errorMsg, LoadingSpinner } from "../Shared";
import * as commonApi from "../../api/commonApi";
import { MappixDesign } from "../Login/index";
import { setEmail, setInviteId, setSessionToken } from "../../store/newuserSlice";

import "../../assets/stlyes/Common/LoginNew.scss";

import Account from "../../assets/images/IconAccount.png";
import RightArrow from "../../assets/images/RightArrow.png";
import HexagonCharacter from "../../assets/images/HexagonCharacter.png";

const NewUser = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const emailRef = useRef(null);
  const otpRef = useRef(null);
  const dispatch = useDispatch();

  const LoginValidationSchema = Yup.object().shape({
    email: Yup.string().trim(" ").required(Common.Required),
    otp: Yup.string().required(Common.Required).min(6),
  });

  const _newUserLogin = async (formData) => {
    setIsLoading(true);
    var email = formData.email;
    var otp = parseInt(formData.otp)
    const otpAuth = await commonApi.user2FA({ email: email, otp: otp });
    if (isEmptyObject(otpAuth)) {
      errorMsg(MESSAGES.LOGIN_FAILED)
    } else {
      dispatch(setEmail(formData.email));
      dispatch(setSessionToken(otpAuth.Items.jwt));
      dispatch(setInviteId(otpAuth.Items.id));
      SessionStorage.setItem(SessionStorageKeys.SessionToken, otpAuth.Items.jwt)
      navigate(InviteUser.setPassword)
    }
    setIsLoading(false);
  }

  return (
    <>
      <div className="main-login">
        {isLoading && <LoadingSpinner />}
        <div className="left-part">
          <div className="first-div"><MappixDesign /></div>
        </div>
        <div className="right-part">
          <div className="first-div">
            <p className="welcome-title">{Common.Welcome}</p>
            <Formik initialValues={{ email: "", otp: "" }} validationSchema={LoginValidationSchema} onSubmit={(values) => {
              const formData = {
                email: values.email.trim(" ").toLowerCase(),
                otp: values.otp,
              }; _newUserLogin(formData);
            }}>
              {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                <Form onSubmit={handleSubmit}>
                  <Form.Group>
                    <p>{MESSAGES.Please_Enter_Your_Email_Address}</p>
                    <Form.Control id="userNamePlaceholder" type="email" name="email" placeholder={Common.EmailExample} onChange={handleChange} onBlur={handleBlur} value={values.email} className={touched.email && errors.email ? "user_email" : "user_email_active"} ref={emailRef} autoComplete="off" />
                    <img src={Account} alt="Acc" className="AcoountLogo" />
                    {touched.email && errors.email ? (<p className="error-message">{errors.email}</p>) : <p>{""}</p>}
                  </Form.Group>
                  <Form.Group>
                    <p>{MESSAGES.Please_Enter_Otp_Sent}</p>
                    <Form.Control type="text" pattern="[0-9]*" name="otp" id="userPasswordPlaceholder" placeholder={Common.Otp} onChange={handleChange} onBlur={handleBlur} value={values.otp} className={touched.otp && errors.otp ? "user_password" : "user_password_active"} ref={otpRef} autoComplete="off" />
                    {touched.otp && errors.otp ? (<p className="error-message enterOTP">{errors.otp}</p>) : <p>{""}</p>}
                  </Form.Group>
                  <Form.Group className="submit-button-div-invite justify-content-center" >
                    <button type="submit" className="submit-button">{Common.SignIn}
                      <img src={RightArrow} alt="Submit" type="image" width="65px" className="login-icon" />
                    </button>
                  </Form.Group>
                </Form>
              )}
            </Formik>
          </div>
          <div className="second-div"><img src={HexagonCharacter} className="hexagon-logo" alt="hexagon-character"></img></div>
        </div>
      </div>
    </>
  );
}

export { NewUser };